/**
 * lucide-default — the original AtelierCode pack. Mirrors the hard-coded
 * `getFileIcon` that lived in FilesTab.tsx before Phase 5 of the file tree
 * rebuild. Kept as the default so existing users see no visual change.
 */
import {
  File,
  FileCode,
  FileImage,
  FileJson,
  FileText,
  FileType,
  Folder,
  FolderOpen,
} from 'lucide-react';
import type { IconPack } from './types';

export const lucideDefault: IconPack = {
  id: 'lucide-default',
  name: 'Lucide (Default)',
  description: 'The classic AtelierCode set — colored Lucide icons by extension.',

  getFileIcon(fileName) {
    const ext = fileName.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'ts':
      case 'tsx':
      case 'js':
      case 'jsx':
        return <FileCode className="w-4 h-4 text-primary" />;
      case 'json':
        return <FileJson className="w-4 h-4 text-warning" />;
      case 'md':
      case 'txt':
        return <FileText className="w-4 h-4 text-base-content/50" />;
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'svg':
        return <FileImage className="w-4 h-4 text-secondary" />;
      case 'html':
      case 'css':
        return <FileType className="w-4 h-4 text-accent" />;
      default:
        return <File className="w-4 h-4 text-base-content/50" />;
    }
  },

  getFolderIcon(_folderName, open) {
    return open
      ? <FolderOpen className="w-4 h-4 text-warning" />
      : <Folder className="w-4 h-4 text-warning" />;
  },
};
